import courseCategoryService from '../services/courseCategory'
import {
  LOAD_CATEGORY,
  CREATE_CATEGORY,
  GET_ALL_CATEGORY
} from '../actions/courseCategory'
import { notification } from 'antd'


const courseCategoryReducer = (
  state = { data: [], loading: false },
  action
) => {
  switch (action.type) {
    case LOAD_CATEGORY:
      return { data: state.data, loading: true }
    case GET_ALL_CATEGORY:
      return { data: action.data, loading: false }
    case CREATE_CATEGORY:
      return { data: action.data, loading: false }
    default:
      return state
  }
}

export const getAllCategory = () => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_CATEGORY })
      const response = await courseCategoryService.getAllCategory()
      dispatch({ type: GET_ALL_CATEGORY, data: response })
    } catch (error) {
      console.log(error)
      notification.error({
        message: `Couldn't load categories`
      })
    }
  }
}

export const createCategory = (category) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_CATEGORY })
      const response = await courseCategoryService.createCategory(category)
      dispatch({ type: CREATE_CATEGORY, data: response })
      notification.success({
        message: 'Category added successfully'
      })
      return response
    } catch (error) {
      console.log(error)
      notification.error({
        message: "Couldn't add category"
      })
      throw error
    }
  }
}

export const toggleCategoryStatus = (categoryId) => {
  return async (dispatch) => {
    try {
      dispatch({ type: LOAD_CATEGORY })
      const response = await courseCategoryService.toggleCategoryStatus(categoryId)
      dispatch({ type: GET_ALL_CATEGORY, data: response })
      notification.success({
        message: 'Category status updated successfully'
      })
    } catch (error) {
      console.log(error)
      notification.error({
        message: "Couldn't update category status"
      })
    }
  }
}

export default courseCategoryReducer
